module.exports = __webpack_public_path__ + "static/media/store-alt.f008d866.svg";